import React from 'react';
import { EditorialHero } from './EditorialHero';

const ArrowIcon = () => (
	<svg viewBox="0 0 24 24" aria-hidden="true">
		<path d="M4 12h15M13 6l6 6-6 6" fill="none" stroke="currentColor" strokeWidth="1.6" />
	</svg>
);

export const AboutPage: React.FC = () => (
	<main className="editorial-page about-editorial">
        <EditorialHero eyebrow="Company" title="Complex problems." accent="Considered solutions." description="Cognixis turns AI research into useful software. We build our own products and partner with organizations to bring ambitious ideas to life." variant="about" href="#our-approach" action="Inside Cognixis" />

		<section id="our-approach" tabIndex={-1} className="about-editorial__story" data-page-reveal>
			<div className="about-editorial__section-label"><span>01</span><p>Mission & Purpose</p></div>
			<div className="about-editorial__story-body">
				<h2>Transforming ambitious ideas into production-grade systems.</h2>
				<div>
					<p>We ground every initiative in rigorous problem definition, advancing methodically from foundational research and systems architecture to rapid prototyping and empirical validation.</p>
					<p>Alongside engineering our own portfolio of proprietary intelligent platforms, we partner with industry leaders to build AI software with attention to reliability, privacy, and measurable goals.</p>
				</div>
			</div>
		</section>

		<section className="about-editorial__method" data-page-reveal>
			<div className="about-editorial__section-label about-editorial__section-label--dark"><span>02</span><p>Engineering Methodology</p></div>
			<div className="about-editorial__method-list">
				<article>
					<span>01</span>
					<h3>Problem Discovery & Framing</h3>
					<p>We engage directly with domain experts and stakeholders to isolate core operational bottlenecks, define technical constraints, and establish clear success metrics.</p>
				</article>
				<article>
					<span>02</span>
					<h3>Iterative Architecture</h3>
					<p>We develop high-fidelity functional prototypes early, validating critical technical hypotheses and rapidly incorporating empirical feedback into system design.</p>
				</article>
				<article>
					<span>03</span>
					<h3>Hardening & Optimization</h3>
					<p>We stress-test systems against real-world workloads, evaluating computational performance, model reliability, data integrity, and security requirements.</p>
				</article>
				<article>
					<span>04</span>
					<h3>Deployment & Scaled Value</h3>
					<p>Our deployment work focuses on stability, usable workflows, and the goals agreed for each project.</p>
				</article>
			</div>
		</section>

		<section className="about-editorial__standard" data-page-reveal>
			<p>Our Standard</p>
			<h2>Pragmatic in utility.<br />Resilient in production.<br /><em>Intuitive and transparent by design.</em></h2>
		</section>

		<section className="about-editorial__contact" data-page-reveal>
			<p>Collaborate with Cognixis</p>
			<h2>Partner with us to engineer intelligent software.</h2>
			<a href="mailto:support@cognixisai.com?subject=AI%20project%20inquiry">support@cognixisai.com <ArrowIcon /></a>
		</section>
	</main>
);

